import React, { lazy, Suspense } from 'react'
import germanTable from './locales/de_table.yml'
import frenchTable from './locales/fr_table.yml'
import { LocaleContext } from '../../contexts/locale'
import './styles.scss'

const MunicipalityChartContainer = lazy(() =>
  import('components/municipalityChartContainer/component')
)

const TABLE_TEXT = {
  de: germanTable,
  fr: frenchTable
}

class VotationResultsTable extends React.Component {
  static contextType = LocaleContext

  state = {
    showAll: false,
    federal_results: [],
    cantonal_results: [],
    participation: null,
    municipality: null,
    canton: null
  }

  makeTable() {
    if (this.props.table) {
      let table = this.props.table

      table = table.replace(/:,/g, ':"",')
      table = table.replace(/:}/g, ':""}')

      try {
        table = JSON.parse(table)
        // console.log(table)

        // Is there any cantonal object?
        if (
          table.cantonal_results.reduce(
            (a, b) => a + b.results.canton.yes.abs,
            ''
          ) === ''
        ) {
          table.cantonal_results = []
        }

        this.setState({
          municipality: table.municipality,
          canton: table.canton,
          federal_results: table.federal_results,
          cantonal_results: table.cantonal_results,
          participation: table.participation,
          maxPct: 100
        })
      } catch (e) {
        console.error(e)
      }
    }
  }

  componentDidMount() {
    this.makeTable()
  }

  componentDidUpdate(prevProps) {
    if (this.props.table !== prevProps.table) {
      this.makeTable()
    }
  }

  formatNumber(n) {
    const numberArray = []

    while (n > 1000) {
      const s = n.toString()
      numberArray.unshift(s.slice(s.length - 3, s.length))
      n = Math.floor(n / 1000)
    }

    numberArray.unshift(n.toString())

    return numberArray.map((p, i) => (
      <span key={i}>
        {p}
        {i < numberArray.length - 1 ? <span /> : ''}
      </span>
    ))
  }

  getArrowDirection(value) {
    if (value > 2) {
      return 'very up'
    } else if (value > 0.5) {
      return 'up'
    } else if (value > 0) {
      return 'right'
    } else if (value < -2) {
      return 'very down'
    } else if (value < -0.5) {
      return 'down'
    }
  }

  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  render() {
    const translate = TABLE_TEXT[this.context]
    const cantonDet = {
      'du ': ['JU', 'TI', 'VS'],
      "d'": ['AE', 'AI', 'OW', 'AG'],
      'des ': ['GR']
    }
    let det = ' de '
    const specialLabels = []

    if (this.state.canton) {
      for (const k in cantonDet) {
        if (cantonDet[k].includes(this.state.canton.short)) {
          det = ' ' + k
          continue
        }
      }

      // Hard coded speciality for the 09.02.2020 votations
      /* if (this.state.canton.fr === 'Zurich') {
        const element = this.state.cantonal_results[4]
        this.state.cantonal_results.splice(4, 1)
        this.state.cantonal_results.splice(2, 0, element)

        specialLabels = [
          this.state.cantonal_results[3].name,
          this.state.cantonal_results[4].name
        ]
      } else if (this.state.canton.fr === 'Bâle-Ville') {
        specialLabels = [
          this.state.cantonal_results[0].name,
          this.state.cantonal_results[2].name
        ]
      } */
    }

    return (
      <div id='results' className='results'>
        {this.state.federal_results.length > 0 &&
          ['all', 'federal'].includes(this.props.showOnly[0]) && (
            <div className='ui raised segment'>
              {/* <h4>{translate.federal_objects}</h4> */}
              <div className='result-table'>
                {this.state.federal_results.map((r, i) => {
                  const municipalityYes =
                    r.results.municipality.yes.abs >
                    r.results.municipality.no.abs
                  const cantonYes =
                    r.results.canton.yes.abs > r.results.canton.no.abs
                  const countryYes =
                    'country' in r.results
                      ? r.results.country.yes.abs > r.results.country.no.abs
                      : null

                  const node = (
                    <table key={'table-federal-' + i}>
                      <thead>
                        <tr>
                          <th colSpan='2'>{this.capitalize(r.name[this.context])}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{this.state.municipality[this.context]}</td>
                          <td>
                            <div>
                              <span className={municipalityYes ? 'yes' : 'no'}>
                                {municipalityYes
                                  ? r.results.municipality.yes.pct
                                  : r.results.municipality.no.pct}
                                %{' '}
                                {municipalityYes ? translate.yes : translate.no}
                              </span>
                            </div>
                            <div className='absolute'>
                              {this.formatNumber(
                                r.results.municipality.yes.abs
                              )}{' '}
                              {translate.yes},{' '}
                              {this.formatNumber(r.results.municipality.no.abs)}{' '}
                              {translate.no}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {translate.canton}
                            {this.context === 'fr' ? det : ' '}
                            {this.state.canton[this.context]}
                          </td>
                          <td>
                            <span className={cantonYes ? 'yes' : 'no'}>
                              {cantonYes
                                ? r.results.canton.yes.pct
                                : r.results.canton.no.pct}
                              % {cantonYes ? translate.yes : translate.no}
                            </span>
                          </td>
                        </tr>
                        {r.results.country.yes.pct && (
                          <tr>
                            <td>{translate.switzerland}</td>
                            <td>
                              <span className={countryYes ? 'yes' : 'no'}>
                                <i
                                  className={`icon ${
                                    countryYes ? 'check' : 'times'
                                  } circle`}
                                />
                                <b>
                                  {countryYes
                                    ? r.results.country.yes.pct
                                    : r.results.country.no.pct}
                                </b>
                                %{' '}
                                <b>
                                  {countryYes ? translate.yes : translate.no}
                                </b>
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )

                  if (this.props.showOnly.length > 0) {
                    if (this.props.showOnly[0] === 'federal') {
                      if (i !== this.props.showOnly[1] - 1) return false
                    }
                  }

                  return node
                })}
              </div>
              {this.props.chartData && this.props.chartData.length > 0 && (
                <Suspense fallback={<div className='chart-placeholder' />}>
                  <MunicipalityChartContainer
                    selectedMunicipalityNumber={this.props.municipalityNumber}
                    data={this.props.chartData}
                    locale={this.context}
                  />
                </Suspense>
              )}
            </div>
          )}

        {this.state.cantonal_results.length > 0 &&
          ['all', 'cantonal'].includes(this.props.showOnly[0]) && (
            <div className='ui raised segment'>
              {/* <h4>{translate.cantonal_objects}</h4> */}
              <div className='result-table'>
                {this.state.cantonal_results.map((r, i) => {
                  if (r.name.fr !== '(blank)' && r.name.fr !== '') {
                    const municipalityYes =
                      r.results.municipality.yes.abs >
                      r.results.municipality.no.abs

                    const cantonYes =
                      r.results.canton.yes.abs > r.results.canton.no.abs

                    const special =
                      r.name.fr === 'Question subsidaire' ||
                      r.name.fr === 'Question subsidiaire'
                    const colorClass = special ? 'special ' : ''

                    let munResult = ''
                    let canResult = ''

                    if (!special) {
                      munResult = municipalityYes ? translate.yes : translate.no
                      canResult = cantonYes ? translate.yes : translate.no
                    } else {
                      munResult = municipalityYes
                        ? specialLabels[0][this.context]
                        : specialLabels[1][this.context]
                      canResult = cantonYes
                        ? specialLabels[0][this.context]
                        : specialLabels[1][this.context]
                    }

                    const node = (
                      <table key={'table-cantonal-' + i}>
                        <thead>
                          <tr>
                            <th colSpan='2'>{r.name[this.context]}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{this.state.municipality[this.context]}</td>
                            <td>
                              <div>
                                <span
                                  className={
                                    colorClass +
                                    (municipalityYes ? 'yes' : 'no')
                                  }
                                >
                                  {municipalityYes
                                    ? r.results.municipality.yes.pct
                                    : r.results.municipality.no.pct}
                                  % {munResult}
                                </span>
                              </div>
                              {!special && (
                                <div className='absolute'>
                                  {this.formatNumber(
                                    r.results.municipality.yes.abs
                                  )}{' '}
                                  {translate.yes},{' '}
                                  {this.formatNumber(
                                    r.results.municipality.no.abs
                                  )}{' '}
                                  {translate.no}
                                </div>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {translate.canton}
                              {this.context === 'fr' ? det : ' '}
                              {this.state.canton[this.context]}
                            </td>
                            <td>
                              <span
                                className={
                                  colorClass + (cantonYes ? 'yes' : 'no')
                                }
                              >
                                <i
                                  className={`icon ${
                                    cantonYes ? 'check' : 'times'
                                  } circle`}
                                />
                                <b>
                                  {cantonYes
                                    ? r.results.canton.yes.pct
                                    : r.results.canton.no.pct}
                                  % {canResult}
                                </b>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )

                    if (this.props.showOnly.length > 0) {
                      if (this.props.showOnly[0] === 'cantonal') {
                        if (i !== this.props.showOnly[1] - 1) return false
                      }
                    }

                    return node
                  }
                })}
              </div>
            </div>
          )}

        {this.state.participation &&
          ['all', 'participation'].includes(this.props.showOnly[0]) && (
            <div className='ui raised segment'>
              <h4>{translate.participation}</h4>
              <div className='result-table'>
                <table>
                  <tbody>
                    <tr>
                      <td>{this.state.municipality[this.context]}</td>
                      <td>
                        <div>
                          <span>{this.state.participation.municipality}%</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {translate.canton}
                        {this.context === 'fr' ? det : ' '}
                        {this.state.canton[this.context]}
                      </td>
                      <td>
                        <span>{this.state.participation.canton}%</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{translate.switzerland}</td>
                      <td>
                        <span>
                          <b>{this.state.participation.country}</b>%
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

        {/* <div
          className='more_button'
          onClick={() => {
            this.state.showAll && this._back.simulateClick()
            this.setState(prevState => {
              return { showAll: !prevState.showAll }
            })
          }}
        >
          <Scrollchor ref={ref => (this._back = ref)} to='results' />
          <i
            className={
              'ui icon chevron ' + (this.state.showAll ? 'up' : 'down')
            }
          />
          {this.state.showAll
            ? TABLE_TEXT[this.context]['show_less']
            : TABLE_TEXT[this.context]['show_more']}
          </div> */}
      </div>
    )
  }
}

VotationResultsTable.defaultProps = {
  showOnly: ['all']
}

export default VotationResultsTable
